import { call } from "redux-saga/effects";
import { APIS } from "../../_config";
import { CallApi } from "../api/callApi";
import { sagaFunction } from "../api/functions";

export function* getCashDiscountSettings(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.CASH_DISCOUNT.GET, null, true);
}

export function* insertUpdateCashDiscountSettings(action: any): any {
    yield call(sagaFunction, action, CallApi.PUT, APIS.CASH_DISCOUNT.INSERT_UPDATE, action.payload, true);
}
